iScreenWizard.factory('Mailtemplate', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('mailtemplate', params).then(function (response) {
                var mailtemplates = response.data;
                resolve(mailtemplates);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('mailtemplate/'+id).then(function (response) {
                var mailtemplate = response.data;
                resolve(mailtemplate);
            }, reject);
        });
    };

    return data;
});